import React, { useContext, useEffect, useState } from 'react';
import { Context } from '../../AppContext';
import Service from '../../services/evaluations';
import GeneralService from '../../services/general';
const SurveyView = ({history}) => {
    const [items, setItems] = useState([]);
    const context = useContext(Context);

    useEffect(() => {
        if (context.organisation) {
            Service.getForOrganisation(context.organisation._id)
            .then(items => {
                const sortedItems = GeneralService.sortJSON(items, 'created', '321');
                setItems(sortedItems.slice(0, 8));
            })
            .catch(err => {
                console.log(err);
            });

      
        }
    }, [context.organisation])

    const trimItem = (text) =>{
        if(text.length > 100){
            return text.substring(0,100)+'...';
        }
        return text;
    }

    return (
        <div style={{ backgroundColor: 'white', margin: '12px' ,width:'350px'}} className='padding  radius-right shadow'>
            <h1>Ga verder..</h1>
            {items.map((item, index) => {              
                return <div style={{cursor:'pointer'}} key={item._id} onClick={()=>{history.push('/evaluatie/'+item._id)}}  >
                    <h3>• {item.title}</h3>
                    {item.description && <p><i>{trimItem(item.description)}</i><br /><br /></p>}
                </div>
            })}
            <br />
        </div>
    );
};

export default SurveyView;